import { render, staticRenderFns } from "./StatusQuo.vue?vue&type=template&id=27ca40c3&scoped=true&"
import script from "./StatusQuo.vue?vue&type=script&lang=js&"
export * from "./StatusQuo.vue?vue&type=script&lang=js&"
import style0 from "./StatusQuo.vue?vue&type=style&index=0&id=27ca40c3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ca40c3",
  null
  
)

export default component.exports